import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { AIPTemplateList } from "@wlocalhost/ngx-email-builder";
import { CommonModelPopUpComponent } from "src/app/components/common-model-pop-up/common-model-pop-up.component";
import { PopUpTitles } from "src/app/shared/model/enum";

@Component({
  selector: "tail-template-list",
  templateUrl: "./template-list.component.html",
  styleUrls: ["./template-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateListComponent extends AIPTemplateList {
  modalService = inject(NgbModal);
   enumPopUpTitles = PopUpTitles;

  openDeleteTemplateModal(event: any,index:number) {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "deletePop",
    };
    const modalRef = this.modalService.open(
      CommonModelPopUpComponent,
      modalOption
    );
    modalRef.componentInstance.title = this.enumPopUpTitles.DELETE;
    modalRef.result.then((result) => {
      if (result.confirm == true) {
        this.deleteTemplate(index);
      }
    });
  }
}
